// Chromium's own extension messaging API throws this exact text when a
// browser extension (Redux DevTools, password managers, ad blockers, etc.)
// sends a chrome.runtime message and the tab navigates away before the
// extension responds. It comes from the extension's own code, not ours, so
// it can't be fixed at the source — only filtered out where it surfaces.
const MESSAGE_CHANNEL_CLOSED_NOISE = "message channel closed before a response was received";

export const isBrowserExtensionMessagingNoise = (message: string | null | undefined): boolean =>
  typeof message === "string" && message.includes(MESSAGE_CHANNEL_CLOSED_NOISE);
